import { Injectable } from '@angular/core';
import { ReceiptModal } from '@shared/models/receipt-modal';
import { Subject } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class ReceiptModalService {
  private _receiptModal = new Subject<ReceiptModal>();
  public receiptModal$ = this._receiptModal.asObservable();

  modalClicked(modal: ReceiptModal) {
    this._receiptModal.next(modal);
  }
}
